import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import * as dataLayer from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { DepositLimitFrequency } from '@mobi/api-types'

export type DepositLimitsEvent = {
  interaction_type: 'Set Deposit Limit'
  depositFrequency: DepositLimitFrequency | 'None' | undefined
  limitAmount: string | undefined
  location: undefined
}

const defaultAccountManagementValues: Omit<DepositLimitsEvent, 'interaction_type'> = {
  depositFrequency: undefined,
  limitAmount: undefined,
  location: undefined,
}

export const DepositLimitsTracker = (event: DepositLimitsEvent) =>
  trackEvent(dataLayer.keys.accountManagement, event)

export const trackSetDepositLimit = (
  depositFrequency: DepositLimitFrequency,
  limitAmount: number
) =>
  DepositLimitsTracker({
    interaction_type: 'Set Deposit Limit',
    ...defaultAccountManagementValues,
    depositFrequency,
    limitAmount: limitAmount.toString(),
  })
